import { useState } from 'react';
import { Switch, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Pressable } from '../../../../../commonComponents';
import { GuidelinesPopup } from './GuidelinesPopup';

export const GuideLinesSwitch = ({ onSwitch }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleSwitch = () => {
    setAcceptedTerms(!acceptedTerms);
    onSwitch(!acceptedTerms);
  };

  const label = (
    <Typography as="span">
      I agree to{' '}
      <Pressable onPress={() => setShowPopup(true)}>
        <Typography as="span" bold color={colors.secondary[500]}>
          GoTu’s Shift Guidelines
        </Typography>
      </Pressable>
      .
    </Typography>
  );

  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', marginBottom: 40 }}
      data-testid="guidelines-agreement-toggle"
      data-cy="guidelines-agreement-toggle"
    >
      <Switch
        data-testid="guidelines-toggle-switch"
        data-cy="guidelines-toggle-switch"
        checked={acceptedTerms}
        onChange={handleSwitch}
        label={label}
      />
      {showPopup && <GuidelinesPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
};
